import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface ChatInputContainerProps {
  children: React.ReactNode;
  className?: string;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
}

const ContainerComponent: React.FC<ChatInputContainerProps> = ({
  children,
  className,
  onSubmit,
}) => {
  return (
    <form className={className} onSubmit={onSubmit}>
      {children}
    </form>
  );
};

export const Container: React.FC<ChatInputContainerProps> = (
  props: ChatInputContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'ChatInputContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
